import React from 'react'
import { connect } from 'react-redux'
import { Modal, Form, Input, Button, message } from 'antd';
import * as actionCreators from '../service/ClientLinkCreator'
import intl from 'react-intl-universal';
const FormItem = Form.Item;
class AddCaModal extends React.Component {
  constructor() {
    super()
    this.handleSubmit = this.handleSubmit.bind(this)
  }
  handleSubmit = (e) => {
    e.preventDefault();
    let length = this.props.categoryList.length
    let flag = this.props.flag
    this.props.form.validateFieldsAndScroll((err, values) => {
      if (values.categoryName === "" || typeof (values.categoryName) === "undefined") {
        message.error(intl.get("contentIsNull"));
      } else if (values.categoryName.length > 20) {
        message.error("there are at most 20 characters")
      } else if (flag === 1) {
        this.props.submitForm(values, sessionStorage.getItem("userName"), flag, this.props.selectKey, this.props.form)
      } else if (length === 20) {
        message.error(intl.get("categoryAtMost20"))
      } else {
        this.props.submitForm(values, sessionStorage.getItem("userName"), flag, null, this.props.form)
      }
    });
  }

  initCategoryName = () => {
    let name = "";
    //flag===0 添加
    //flag!==0 修改
    if (!(typeof (this.props.categoryList[0]) === "undefined")) {
      if (this.props.flag === 1 && typeof (this.props.categoryName) === "undefined") {
        name = this.props.categoryList[0].name
      } else if (this.props.flag === 0) {
        name = ""
      } else {
        name = this.props.categoryName
      }
    } else {
      name = ""
    }
    return name
  }

  handleCancel = () => {
    this.props.form.resetFields();
    this.props.handleCancel()
  }

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    return (
      <div>
        <Modal
          title={this.props.title}
          visible={this.props.visible}
          onCancel={this.handleCancel}
          footer={null}
        >
          <Form onSubmit={this.handleSubmit}>
            <FormItem {...formItemLayout}
              label={intl.get("categoryName")}
            >
              {getFieldDecorator('categoryName', {
                rules: [{ required: true, message: intl.get("pleaseEnterCaName") }, { max: 20, message: "there at most 20 characters" }],
                initialValue: this.initCategoryName()
              })(
                <Input style={{ width: 200 }} />
              )}
            </FormItem>
            <FormItem {...tailFormItemLayout}>
              <Button type="primary" htmlType="submit" style={{ marginLeft: 60 }}>{intl.get("submit")}</Button>
            </FormItem>
          </Form>
        </Modal>
      </div>
    )
  }
}
const mapState = (state) => {
  return {
    visible: state.clientLink.visible,
    categoryList: state.clientLink.categoryList,
    flag: state.clientLink.flag,
    categoryName: state.clientLink.categoryName,
    categoryid: state.clientLink.categoryid,
    title: state.clientLink.title,
    selectKey: state.clientLink.selectKey
  }
}
const mapDispatch = (dispatch) => {
  return {
    submitForm(values, userName, flag, cid, form) {
      dispatch(actionCreators.addCategory(values.categoryName, userName, flag, cid, form))
    },

    handleCancel() {
      dispatch(actionCreators.hideModal())
    },

    updateCategory(values, categoryid, userName, flag) {
      dispatch(actionCreators.addCategory(values.categoryName, userName, flag, categoryid))
    }
  }
}

const AddModal = Form.create()(AddCaModal);
export default connect(mapState, mapDispatch)(AddModal);


// WEBPACK FOOTER //
// ./src/components/AddCaModal.js